import styled from 'styled-components'

import PrimaryLink from 'units/PrimaryLink'

export const Container = styled.div`
  padding: 0 10px 20px;
  width: 100%;
`

export const LinkText = styled.div`
  font-size: 14px;
  line-height: 20px;
`

export const Link = styled(PrimaryLink)`
  display: inline-flex;
  margin-left: ${({ marginLeft }) => marginLeft ?? 0}px;
`
